import { render, staticRenderFns } from "./TeacherProfileHub.vue?vue&type=template&id=351a4029"
import script from "./TeacherProfileHub.vue?vue&type=script&lang=js"
export * from "./TeacherProfileHub.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports